export default __webpack_public_path__ + "static/media/skill_illustration.878c2e19.svg";